if (!customElements.get("blog-filters")) {
  class BlogFilters extends HTMLElement {
    constructor() {
      super();
      this.main = document.querySelector(".blog__main");
      this.base_url = this.getAttribute("data-base-url");
      this.query = new URLSearchParams(window.location.search);
      this.query.set("page", this.query.has("page") ? this.query.get("page") : 1);
      this.heading = this.querySelector(".label--heading");
      this.is_loading = false;
      this.content = document.querySelector(".blog__content") || document.querySelector(".collection-grid__items");
      this.tags = this.querySelectorAll(".blog__tags-list button");
      this.load_more = document.querySelector('.collection-grid__load-more[data-load-type="article"]');
      this.current_terms = "";

      this.tags.forEach(tag => {
        tag.addEventListener("click", () => {
          this.tags.forEach(other => {
            other.setAttribute("aria-selected", "false");
            other.classList.remove("active");
          });

          tag.setAttribute("aria-selected", "true");
          tag.classList.add("active");

          this.heading.innerText = tag.innerText;
          this.current_tag = tag.getAttribute("data-value");
          this.updateQuery(true);
          this.updateURL();
          this.fetchArticles(window.location.href, true);
        });
      });

      this.bind();
    }

    updateQuery(reset_page = false) {
      let page = this.query.get("page");
      this.query = new URLSearchParams();

      if (reset_page) {
        page = 1;
      }

      if (this.load_more) {
        this.query.append("type", "article");
        this.query.append("q", this.current_terms);
      } else {
        this.query.append("tagged", this.current_tag);
      }

      this.query.set("page", page);
    }

    updateURL() {
      let url = this.base_url;

      if (this.query.get("tagged")) {
        if (this.query.get("tagged") != "all") {
          url += "/tagged/" + this.query.get("tagged");
        }
        this.query.delete("tagged");
      }

      url += "?" + this.query.toString();
      history.pushState({}, "", url);
    }

    fetchArticles(url, replace = false) {
      if (this.is_loading) return;
      if (!this.load_more) {
        window.scrollTo({
          top: this.main.offsetTop - 50,
          behavior: "smooth"
        });
      }
      this.is_loading = true;
      if (this.main) {
        this.main.classList.add("blog__main--loading");
      }

      fetch(`${url}`, {
        method: "GET"
      })
        .then(response => response.text())
        .then(response => {
          const tmp = document.createElement("div");
          tmp.innerHTML = response;
          const content = tmp.querySelector(".blog__content") || tmp.querySelector(".collection-grid__items");
          const load_more = tmp.querySelector('.collection-grid__load-more[data-load-type="article"]');

          if (content) {
            if (replace) {
              this.content.innerHTML = content.innerHTML;
            } else {
              this.content.innerHTML += content.innerHTML;
            }
            if (load_more) {
              this.load_more.innerHTML = load_more.innerHTML;
            }
            this.bind();
          }

          setTimeout(() => {
            if (this.main) {
              this.main.classList.remove("blog__main--loading");
            }
            this.is_loading = false;
          }, 500);
        });
    }

    bind() {
      document.querySelectorAll(".blog__content .pagination a.pagination__item").forEach(element => {
        element.addEventListener("click", event => {
          event.preventDefault();
          history.pushState({}, "", element.href);
          this.fetchArticles(element.href, true);
        });
      });

      if (this.load_more) {
        this.current_terms = document.querySelector('.collection-grid__load-more[data-load-type="article"]').getAttribute("data-load-terms");

        this.load_more.querySelectorAll("button").forEach(button => {
          button.addEventListener("click", () => {
            const page = parseInt(this.query.get("page")) + 1;
            this.query.set("page", page);
            this.updateQuery(false);
            this.updateURL();
            this.fetchArticles(window.location.href, false);
          });
        });
      }
    }
  }
  customElements.define("blog-filters", BlogFilters);
}
